//
// index.js - main import file (put application code in application.js)
// ------------------------------------------------------------------// 

import '@ungap/custom-elements';
//import "custom-event-polyfill";
//import "whatwg-fetch";

// Import Booststrap components as needed
import { Alert, Toggle, Collapse } from 'bootstrap';

// Import application code
import './application';
import './shame';